export default "__VITE_ASSET__BiHxT1dh__"